const en = {
  login: {
    title: 'Login',
  },
  actions: {
    view: 'View',
    add: 'Add',
    edit: 'Edit',
    cancel: 'Cancel',
    submit: 'Submit',
    update: 'Update',
    save: 'Save',
    back: 'Back',
    delete: 'Delete',
    export: 'Export',
    exportAll: 'Export All',
    download: 'Download',
    generate: 'Generate',
    clear: 'Clear',
    selectAll: 'Select all',
    unselectAll: 'Unselect all',
    preparingFile: 'Preparing file...',
    continue: 'Continue',
    newarticle: 'New article',
    addSPF: 'Add Suggested PF',
  },
  form: {
    fieldRequired: 'This field is required.',
    error: 'Server error',
  },
  label: {
    type: 'Type',
    name: 'Name',
    asset: 'Asset',
    liability: 'Liability',
    expense: 'Expense',
    income: 'Income',
    none: 'None',
    noneF: 'None',
    companyName: 'Company Name',
    address: 'Address',
    email: 'Email',
    phone: 'Phone Number',
    rating: 'Ratings',
    comments: 'Comments',
  },
  user: {
    language: 'Language',
    firstName: 'First name',
    lastName: 'Last name',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    password: 'Password',
    confirm: 'Confirm password',
    type: 'Type',
    address: 'Address',
    member: 'Member',
    role: 'Role',
    typeOptions: {
      standard: 'Co-owner',
      manager: 'Manager',
      administrator: 'Administrator',
      superAdministrator: 'Super Administrator',
      super: 'Super Administrator',
      boardmember: 'Board Member',
    },
    deleteConfirmation: 'This action is irreversible. Are you sure you want to delete this user?',
    userProfile: 'Upload Image',
    uploadDoc: 'Upload Document',
  },
  date: {
    From: 'From',
    from: 'from',
    To: 'To',
    to: 'to',
  },
  accountType: {
    income: 'Income',
    revenu: 'Income',
    assurance: 'Fond Auto Assurance',
    providence: 'Provident fund',
    depenses: 'Expenses',
    expense: 'Expense',
    expenses: 'Expenses',
    profit: 'Profit',
    providentFund: 'Provident fund',
    providentFundShort: 'PF',
    fondAutoAssurance: 'Fond Auto Assurance',
    fondAutoAssuranceshort: 'FAA',
    notVisible: 'Not visible',
    notVisibleShort: 'NV',
    assets: 'Assets',
    actifs: 'Assets',
    passifs: 'Liabilities',
    liabilities: 'Liabilities',
    total: 'Total',
  },
  month: {
    january: 'January',
    febuary: 'Febuary',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    1: 'January',
    2: 'Febuary',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
  },
  coowner: {
    user: 'User',
    user2: 'User 2',
    address: 'Address',
    unit: 'Unit',
    insurance: 'Insurance',
    antitheft: 'Anti-theft',
    share: 'Share',
    animal: 'Animal',
    drd: 'DRD',
    institution: 'Institution',
    charge: 'Charge',
    account: 'Account',
    parking: 'Parking',
    parkingAdditional: 'Additional Parking',
    shed: 'Shed',
    car: 'Car',
    carAdditional: 'Additional Car',
    tenant: 'Tenant',
    startDate: 'Start date',
    endDate: 'End date',
    notes: 'Notes',
  },
  syndicate: {
    syndicateType: 'Syndicate Type',
    type: 'Type',
    clientNumber: 'Client number',
    name: 'Name',
    shortName: 'Short name',
    address: 'Address',
    streetNumber: 'Street number',
    streetName: 'Street name',
    creationDate: 'Creation date',
    organizationNumber: 'Organization number',
    organizationName: 'Organization name',
    account: 'Account',
    institution: 'Computer center',
    institutionNumber: 'Institution number',
    field: 'Field',
    insurance: 'Insurance',
    aga: 'AGA',
    pga: 'PGA',
    rules: 'Rules',
    declaration: 'Declaration',
    req: 'REQ',
    agaDate: 'AGA date',
    acaDate: 'ACA date',
    representative: 'Horizontal rep',
    manager: 'Manager',
    admin: 'Administrator',
    commonCharge: 'Common charge',
    hasTaxes: 'Taxes',
    email: 'Email',
    reportFrequency: 'Report frequency',
    dayOfMonth: 'Day of month',
    boardMember: 'Board Members',
  },
  reportFrequency: {
    monthly: 'Monthly',
    bimonthly: 'Bimonthly',
    quaterly: 'Quaterly',
    fourMonthly: 'Four-monthly',
    semester: 'Semester',
    annually: 'Annually',
  },
  transaction: {
    name: 'Name',
    category: 'Category',
    note: 'Note',
    selection: 'Selection: ',
    transactionsCopied: 'transactions copied',
  },
  notFound: {
    user: 'User not found',
  },
};

export default en;



// WEBPACK FOOTER //
// ./src/i18n/en.js